Flux.Store = function () {
  function Store(changeListeners) {
    this.changeListeners = changeListeners;
    this.dispatcher = Flux.Dispatcher;
    this.changeListeners = [];
    this.actionHandlers = {};
    this.registerWithDispatcher();
  }
  Store.prototype.registerWithDispatcher = function () {
    return this.dispatchToken = this.dispatcher.register(function (_this) {
      return function (payload) {
        return _this.distributePayload(payload);
      };
    }(this));
  };
  Store.prototype.distributePayload = function (payload) {
    if (this.actionHandlers[payload.actionType]) {
      this.actionHandlers[payload.actionType].call(this, payload);
    }
    return true;
  };
  Store.prototype.dispatcherCallback = function (type, callback) {
    return this.actionHandlers[type] = callback;
  };
  Store.prototype.emitChange = function (event) {
    var i, len, listener, ref, results;
    ref = this.changeListeners;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      listener = ref[i];
      results.push(listener(event));
    }
    return results;
  };
  Store.prototype.createAtUrl = function (url, data, success, error) {
    return $.ajax({
      url: url({
        subdomain_param: 'api'
      }),
      type: 'POST',
      contentType: 'application/json; charset=UTF-8',
      data: JSON.stringify(data),
      dataType: 'json',
      success: function (_this) {
        return function (response) {
          return success.call(_this, response);
        };
      }(this),
      error: function (_this) {
        return function (response) {
          return error.call(_this, response);
        };
      }(this)
    });
  };
  Store.prototype.readFromUrl = function (url, success, error) {
    return $.ajax(url, {
      type: 'GET',
      subdomain_param: 'api',
      success: function (_this) {
        return function (response) {
          return success.call(_this, response);
        };
      }(this),
      error: function (_this) {
        return function (response) {
          return error.call(_this, response);
        };
      }(this)
    });
  };
  Store.prototype.updateAtUrl = function (url, data, success, error) {
    data._method = 'PATCH';
    return $.ajax(url, {
      type: 'POST',
      subdomain_param: 'api',
      dataType: 'json',
      data: data,
      success: function (_this) {
        return function (response) {
          return success.call(_this, response);
        };
      }(this),
      error: function (_this) {
        return function (response) {
          return error.call(_this, response);
        };
      }(this)
    });
  };
  Store.prototype.deleteAtUrl = function (url, success, error) {
    return $.ajax(url, {
      type: 'DELETE',
      dataType: 'json',
      success: function (_this) {
        return function (response) {
          return success.call(_this, response);
        };
      }(this),
      error: function (_this) {
        return function (response) {
          return error.call(_this, response);
        };
      }(this)
    });
  };

  /*
   *  Private:
   */

  Store.prototype.addChangeListener = function (listener) {
    return this.changeListeners.push(listener);
  };
  Store.prototype.removeChangeListener = function (toRemove) {
    return this.changeListeners = _.reject(this.changeListeners, function (listener) {
      return listener === toRemove;
    });
  };

  /*
   *  Public:
   */

  Store.prototype.initialize = function (params, handler, context) {
    var onUpdate;
    onUpdate = function (event) {
      return handler.call(context, event);
    };
    this.addChangeListener(onUpdate);
    handler.registeredFluxStoreListener = onUpdate;
    if (this.hasData(params)) {
      return onUpdate();
    } else {
      return this.loadData(params);
    }
  };
  Store.prototype.cleanup = function (handler) {
    return this.removeChangeListener(handler.registeredFluxStoreListener);
  };
  Store.prototype.hasData = function (params) {
    throw new Error('Implement "hasData(params)" for Store');
  };
  Store.prototype.loadData = function (params) {
    throw new Error('Implement "loadData(params)" for Store');
  };
  return Store;
}();